import React from "react"

// eslint-disable-next-line import/order -- must evaluate before the store slice reads localStorage
import "bootstrap/reconcileSso"
import "utils/dayjs"
import "utils/yup/setLocale"
import * as Sentry from "@sentry/react"
import { browserTracingIntegration } from "@sentry/react"
import App from "App"
import AppProviders from "AppProviders"
import { createRoot } from "react-dom/client"

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN as string,
  environment: process.env.REACT_APP_SENTRY_ENV as string,
  integrations: [
    browserTracingIntegration({
      shouldCreateSpanForRequest: (url: string) => {
        const tracingOrigin = process.env.REACT_APP_SENTRY_TRACE as string
        if (!tracingOrigin) return true
        try {
          const urlObj = new URL(url, window.location.origin)
          const originObj = new URL(tracingOrigin)
          return urlObj.origin === originObj.origin
        } catch {
          return url.includes(tracingOrigin)
        }
      },
    }),
  ],
  tracesSampleRate: Number(process.env.REACT_APP_SENTRY_RATE),
})

const container = document.getElementById("root")
if (!container) {
  throw new Error("Failed to find the root element")
}

const root = createRoot(container)
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
)
